import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  icon,
  title,
  desc,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        <h2 className="flex items-center gap-2 text-xl md:text-2xl font-bold text-foreground-950">
          <span className="w-8 h-8 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
            <i className={`${icon} text-lg`} />
          </span>
          {title}
        </h2>
        {desc && (
          <p className="mt-2 text-sm text-foreground-500 max-w-2xl">{desc}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden sm:flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap shrink-0"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}